/**
 * <klapi-sommaire> : surligne dans le sommaire l'intertitre en cours de lecture.
 * Liens [data-sommaire-lien] vers des ancres #id ; les titres ciblés sont observés.
 * En mobile, le sommaire (<details data-sommaire-details>) est replié par défaut
 * et se replie après un clic sur un lien.
 */
// Le script peut être inclus par plusieurs sections : l'élément n'est déclaré qu'une fois
if (!customElements.get('klapi-sommaire')) {
  class KlapiSommaire extends HTMLElement {
    connectedCallback() {
      this.liens = [...this.querySelectorAll('[data-sommaire-lien]')];
      this.details = this.querySelector('[data-sommaire-details]');
      const mobile = window.matchMedia('(max-width: 989px)');
      if (this.details && mobile.matches) this.details.open = false;

      const titres = this.liens
        .map((lien) => document.getElementById(decodeURIComponent(lien.hash.slice(1))))
        .filter(Boolean);
      if (!titres.length) return;

      const visibles = new Set();
      const observateur = new IntersectionObserver(
        (entrees) => {
          entrees.forEach((entree) => {
            if (entree.isIntersecting) visibles.add(entree.target);
            else visibles.delete(entree.target);
          });
          // Le titre actif est le premier visible, sinon le dernier passé au-dessus
          let actif = titres.find((t) => visibles.has(t));
          if (!actif) actif = titres.filter((t) => t.getBoundingClientRect().top < 0).pop();
          this.activer(actif);
        },
        { rootMargin: '0px 0px -65% 0px' }
      );
      titres.forEach((titre) => observateur.observe(titre));

      this.liens.forEach((lien) =>
        lien.addEventListener('click', () => {
          if (this.details && mobile.matches) this.details.open = false;
        })
      );
    }

    activer(titre) {
      this.liens.forEach((lien) => {
        const correspond = titre && lien.hash === `#${titre.id}`;
        if (correspond) lien.setAttribute('aria-current', 'true');
        else lien.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('klapi-sommaire', KlapiSommaire);
}
